export type ButtonVariant = 'primary' | 'secondary' | 'social';

export const BUTTON_VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: 'tw-bg-component-button-primary-background tw-text-component-button-primary-text tw-border-component-button-primary-border-size tw-border-component-button-primary-border',
  secondary: 'tw-bg-component-button-secondary-background tw-text-component-button-secondary-text tw-border-component-button-secondary-border-size tw-border-component-button-secondary-border',
  social: 'tw-bg-component-button-social-background tw-text-component-button-social-text tw-border-component-button-social-border-size tw-border-component-button-social-border',
};

export const BUTTON_ACTION_VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: 'hover:tw-bg-component-button-primary-background-hover hover:tw-text-component-button-primary-text-hover hover:tw-border-component-button-primary-border-hover',
  secondary: 'hover:tw-bg-component-button-secondary-background-hover hover:tw-text-component-button-secondary-text-hover hover:tw-border-component-button-secondary-border-hover',
  social: 'hover:tw-bg-component-button-social-background-hover hover:tw-text-component-button-social-text-hover hover:tw-border-component-button-social-border-hover',
};


export const SPINNER_STROKE_VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: 'tw-stroke-component-button-primary-text',
  secondary: 'tw-stroke-component-button-secondary-text',
  social: 'tw-stroke-component-button-social-text',
};
